import { inject, Injectable } from '@angular/core';
import { HttpGatewayService } from '../../global/services/http-gateway.service';
import { Observable } from 'rxjs';
import {
  SegmentContract,
  SegmentUsageContract,
  UpdateSegmentContract,
} from '../store/segments/types';

@Injectable({ providedIn: 'root' })
export class SegmentsApi {
  private httpService = inject(HttpGatewayService);

  public getSegments(
    salesOrganizationId: string,
    clusterId: string,
  ): Observable<SegmentContract[]> {
    return this.httpService.get<SegmentContract[]>(
      `/segments/${salesOrganizationId}/${clusterId}`,
    );
  }

  public updateSegments(
    salesOrganizationId: string,
    clusterId: string,
    segments: UpdateSegmentContract[],
  ): Observable<SegmentContract[]> {
    return this.httpService.put<SegmentContract[]>(
      `/segments/${salesOrganizationId}/${clusterId}`,
      segments,
    );
  }

  public getSegmentUsage(
    salesOrganizationId: string,
    clusterId: string,
  ): Observable<SegmentUsageContract[]> {
    return this.httpService.get<SegmentUsageContract[]>(
      `/segments/${salesOrganizationId}/${clusterId}/usage`,
    );
  }
}
